"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedTreeNode = void 0;
const product_tree_node_1 = require("../client/product-tree-node");
const store_1 = require("../../store");
const useSelectedTreeNode = () => {
    const selectedStrategyNodeId = (0, store_1.useSelectedTreeNodeId)();
    const response = (0, product_tree_node_1.useProductTreeNode)({ id: selectedStrategyNodeId });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.useSelectedTreeNode = useSelectedTreeNode;
